import React from 'react';
import { NavLink } from 'react-router-dom';

const EmptyPage = ({ text = 'No tienes registros.', isCallToAction = false, btnText = '', path = '', showAnimation = false }) => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center p-4 w-100 m-auto mb-5 bg-infox"
      style={{ minHeight: '60vh', maxWidth: '700px' }}
    >
      {showAnimation && <img alt="pagina vacia" src="/img/animation/empty.gif" style={{ width: '150px', height: '150px' }} />}
      <div className="text-center my-5 mb-5 h3">{text}</div>
      {isCallToAction && (
        <NavLink to={path} className="btn btn-icon btn-primary btn-icon-start ms-0 ms-sm-1 w-md-auto text-decoration-none">
          <span>{btnText}</span>
        </NavLink>
      )}
    </div>
  );
};
export default EmptyPage;
